import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import DeviceSelect from "./deviceSelect";
import CustomerForm from "./customerForm";
import CardForm from "./cardForm";
import DeviceProtection from "./deviceProtection";
import ThankYou from "./thankYou";

const stripePromise =
  process.env.NODE_ENV === "development"
    ? loadStripe("pk_test_VVwit0NMS5sz8n96rNCRDQwp")
    : loadStripe("pk_live_xM0HfG1GRrrqfT57w817Qnzi");

export default function CheckoutPage() {
  const [formStage, setFormStage] = useState("deviceselect");
  const [deviceSelection, setDeviceSelection] = useState();
  const [customerData, setCustomerData] = useState();
  const [deviceProtection, setDeviceProtection] = useState();
  const [paymentMethod, setPaymentMethod] = useState();
  const isCreateCustomerFirstRun = useRef(true);
  useEffect(() => {
    if (isCreateCustomerFirstRun.current) {
      isCreateCustomerFirstRun.current = false;
      return;
    } else {
      console.log(
        "Creating customer with this data:",
        deviceSelection,
        customerData,
        paymentMethod,
        deviceProtection
      );
      if(process.env.NODE_ENV === "development"){
        axios
        .post("/checkoutapi/checkoutapi/createCustomer", {
          device_selection: deviceSelection,
          customer_data: customerData,
          payment_method: paymentMethod,
          device_protection: deviceProtection,
        })
        .then(function(response){
          console.log(response);
          window.location.href = "https://motusnova.com/trial/thank-you";
        })
        .catch(function(error){
          console.log(error);
          window.location.href = "https://motusnova.com/trial/thank-you";
        });
      }
      else{
        axios
        .post("https://motusnova.com/checkoutapi/createCustomer", {
          device_selection: deviceSelection,
          customer_data: customerData,
          payment_method: paymentMethod,
          device_protection: deviceProtection,
        })
        .then(function(response){
          console.log(response);
          window.location.href = "https://motusnova.com/trial/thank-you";
        })
        .catch(function(error){
          console.log(error);
          window.location.href = "https://motusnova.com/trial/thank-you";
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceProtection]);

  const handleCustomerFormSubmit = (data) => {
    //ultimately called by customerForm.js
    setCustomerData({ ...customerData, data });
  };
  const handlePaymentMethodSubmit = (data) => {
    //ultimately called by cardForm.js
    setPaymentMethod({ ...paymentMethod, data });
  };
  const handleDeviceProtectionSubmit = (data) => {
    //ultimately called by deviceProtection.js
    setDeviceProtection({ ...deviceProtection, data });
  };
  const handleDeviceSelect = (data) => {
    //ultimately called by deviceCard.js
    setDeviceSelection({ ...deviceSelection, data });
  };
  const handleFormChange = (data) => {
    //called on each of the above.
    // timeout makes it feel more fluid
    setTimeout(() => {
      setFormStage(data);
    }, 200);
  };

  return formStage === "customer" ? (
    <CustomerForm
      onSubmit={handleCustomerFormSubmit}
      defaultValues={customerData}
      handleFormChange={handleFormChange}
      deviceSelection={deviceSelection}
    />
  ) : formStage === "payment" ? (
    <Elements stripe={stripePromise}>
      <CardForm
        onSubmit={handlePaymentMethodSubmit}
        handleFormChange={handleFormChange}
        deviceSelection={deviceSelection}
      />
    </Elements>
  ) : formStage === "protection" ? (
    <DeviceProtection
      onSubmit={handleDeviceProtectionSubmit}
      handleFormChange={handleFormChange}
    />
  ) : formStage === "deviceselect" ? (
    <DeviceSelect
      handleFormChange={handleFormChange}
      handleDeviceSelect={handleDeviceSelect}
    />
  ) : null;
}
